'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import styles from './countdown-spinner.module.scss';
export const CountdownSpinner = t0 => {
  const $ = _c(21);
  const {
    className,
    duration,
    onCountdownEnd,
    paused
  } = t0;
  const startTime = useRef(null);
  const pausedRef = useRef(undefined);
  const [elapsedTime, setElapsedTime] = useState(0);
  const circumference = 2 * Math.PI * 18;
  const remainingTime = Math.max(duration - elapsedTime, 0);
  const progress = remainingTime / duration * 100;
  const offset = circumference - progress / 100 * circumference * -1;
  const remainingSeconds = Math.ceil(remainingTime);
  let t1;
  let t2;
  if ($[0] !== paused) {
    t1 = () => {
      pausedRef.current = paused;
    };
    t2 = [paused];
    $[0] = paused;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== duration) {
    t3 = () => {
      const animate = timestamp => {
        if (!startTime.current) {
          startTime.current = timestamp;
        }
        const elapsedSeconds = (timestamp - startTime.current) / 1000;
        if (pausedRef.current) {
          setElapsedTime(oldElapsedTime => {
            startTime.current = timestamp - oldElapsedTime * 1000;
            return oldElapsedTime;
          });
        } else {
          setElapsedTime(elapsedSeconds);
        }
        if (elapsedSeconds < duration) {
          requestAnimationFrame(animate);
        }
      };
      const animationId = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationId);
    };
    t4 = [duration];
    $[3] = duration;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== onCountdownEnd || $[7] !== remainingSeconds) {
    t5 = () => {
      if (remainingSeconds === 0) {
        onCountdownEnd();
      }
    };
    t6 = [onCountdownEnd, remainingSeconds];
    $[6] = onCountdownEnd;
    $[7] = remainingSeconds;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== className) {
    t7 = classNames(className, styles["countdown-spinner-container"]);
    $[10] = className;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <circle cx={20} cy={20} r={20} />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== offset) {
    t9 = <svg className={styles["countdown-spinner"]} height={40} width={40}>{t8}<circle className={styles["countdown-spinner__circle"]} cx={20} cy={20} fill="none" r={18} strokeDasharray={circumference} strokeDashoffset={offset} strokeWidth={4} /></svg>;
    $[13] = offset;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== remainingSeconds) {
    t10 = <span className={styles["countdown-spinner__count"]}>{remainingSeconds}</span>;
    $[15] = remainingSeconds;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7 || $[19] !== t9) {
    t11 = <div className={t7}>{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};